import React, { useState } from 'react';
import { toast } from 'react-toastify';
import api from '../../services/api';
import { useAuth } from '../../contexts/auth';
import { EstimateViewModel } from '../../models/estimate/EstimateViewModel';
import EstimateStatus from '../../enums/EstimateStatus';
import EstimateFoo from './EstimateFoo';

interface EstimateActionButtonsProps {
  estimate: EstimateViewModel;
  refreshEstimate: () => void;
}

type EstimateStatusModel = {
  id: number;
  label: string;
  state: EstimateStatus;
};

export default function EstimateActionButtons({
  estimate,
  refreshEstimate,
}: EstimateActionButtonsProps) {
  const {
    user: { organization },
  } = useAuth();

  const [isChangingStatus, setIsChangingStatus] = useState(false);
  const [statusStates, setStatusStates] = useState<EstimateStatusModel[]>([]);
  const [isOpenModal, setIsOpenModal] = useState(false);

  async function updateEstimateState(status: EstimateStatus) {
    setIsChangingStatus(true);
    try {
      await api.patch(
        `organizations/${organization.id}/estimates/${estimate.id}`,
        { status }
      );
      refreshEstimate();
    } catch (e: any) {
      if (e?.response?.status === 409) {
        toast.error(
          e?.response?.data?.errors.reduce(
            (acc: string, error: string) => acc + error,
            ''
          )
        );
      } else {
        toast.error('Houve um problema ao processar a sua solicitação');
      }
      console.error(e);
    } finally {
      setStatusStates([]);
      setIsChangingStatus(false);
    }
  }
  const changeStatus = (status: number) => {
    if (
      // eslint-disable-next-line no-restricted-globals
      confirm(
        'Você deseja alterar o status do Orçamento? Essa ação não poderá ser desfeita'
      )
    ) {
      updateEstimateState(status);
    }
  };

  return (
    <div>
      {isChangingStatus ? (
        <div className='d-flex placeholder-glow text-end'>
          <span className='placeholder col-3 mx-1'>&nbsp;</span>
          <span className='placeholder col-1 mx-1'>&nbsp;</span>
          <span className='placeholder col-2 mx-1'>&nbsp;</span>
        </div>
      ) : (
        <div className='d-flex justify-content-end gap-2'>
          {estimate.status === EstimateStatus.Draft && (
            <button
              type='button'
              className='btn btn-primary'
              onClick={() => changeStatus(EstimateStatus.Wip)}
            >
              Iniciar
            </button>
          )}
          {estimate.status === EstimateStatus.Draft ||
            (estimate.status === EstimateStatus.Wip && (
              <button
                type='button'
                className='btn btn-dark'
                onClick={() => changeStatus(EstimateStatus.Canceled)}
              >
                Cancelar
              </button>
            ))}
          {estimate.status === EstimateStatus.Wip && (
            <button
              type='button'
              className='btn btn-outline-success'
              onClick={() => changeStatus(EstimateStatus.Completed)}
            >
              Aprovar
            </button>
          )}
          {estimate.status === EstimateStatus.Completed && (
            <>
              <button
                type='button'
                className='btn btn-outline-success'
                onClick={() => setIsOpenModal(true)}
              >
                Incluir Ordens de Serviço
              </button>
              <button
                type='button'
                className='btn btn-outline-secondary'
                onClick={() => changeStatus(EstimateStatus.Wip)}
              >
                Reabrir
              </button>
            </>
          )}
        </div>
      )}
      <EstimateFoo
        estimate={estimate}
        isOpen={isOpenModal}
        setIsOpenModal={setIsOpenModal}
      />
    </div>
  );
}
